<template>
  <portal to="modal" v-if="value">
      <div class="modal_wrapper py4" @click="hide">
        <div
          class="grow flex modal card"
          style="flex-direction: column"
          @click.stop
          :class="cardClass"
        >
          <div
            class="modal_header"
            :class="headerClass"
          >
            <span
              @click="hide"
            >
              <slot
                name="close"
              >
                <icon cross/>
              </slot>
            </span>
          </div>

          <slot/>
        </div>
      </div>
  </portal>
</template>

<script>

export default {
  name: 'modal',
  props: {
    value: Boolean,
    title: String,
    headerClass: { type: String, default: 'px2 py2' },
    cardClass: { type: String, default: 'pa0' },
  },

  methods: {
    hide() {
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss" scoped>
  .modal_wrapper {
    position: relative;
    width: 100%;
    z-index: 999;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    background: rgba(0, 0, 0, 0.6);
  }

  .modal {
    max-width: $app_screen_width;
    max-height: 90vh;
    overflow-y: auto;
    background: white;
    z-index: 50;
    margin: auto 24px !important;
  }

  .modal_header {
    position: absolute;
    right: 20px;
    z-index: 999;
    margin-bottom: -50px;
    display: flex;
    justify-content: flex-end;
    border-radius: $border_radius $border_radius 0 0;
    margin-top: -1px;
  }
</style>
